import { jsx as e } from "react/jsx-runtime";
import { c as s } from "../clsx-OuTLNxxd.js";
import { ImageRatio as d } from "../ImageRatio/ImageRatio.js";
import { c as n } from "../background-DsFsjTc7.js";
const u = "PictureCard-module_picture-card__OY73K",
  m = "PictureCard-module_with-border__RXttM",
  l = "PictureCard-module_title__Kzyrs",
  t = {
    pictureCard: u,
    withBorder: m,
    title: l
  },
  P = _ref => {
    let {
      borderColor: r = "transparent",
      background: a = "white",
      trackingName: o,
      children: c
    } = _ref;
    const i = n(a);
    return /* @__PURE__ */e("div", {
      className: s(t.pictureCard, i, {
        [t.withBorder]: r != "transparent"
      }),
      "data-content-name": o,
      children: c
    });
  },
  w = _ref2 => {
    let {
      children: r
    } = _ref2;
    return /* @__PURE__ */e(d, {
      ratio: "card",
      children: r
    });
  },
  f = _ref3 => {
    let {
      children: r
    } = _ref3;
    return /* @__PURE__ */e("h3", {
      className: t.title,
      children: r
    });
  };
export { P as PictureCard, w as PictureCardImage, f as PictureCardTitle };